import * as React from 'react';

import { cn } from '@/design/utils';

/**
 * A multi-line text control, matching the single-line {@link Input}'s ring, border and invalid
 * states so that a form built from both does not read as two forms.
 *
 * `field-sizing-content` lets the box grow with what is typed rather than sitting at a fixed height
 * with a scrollbar: the one long-text field in this product is an operator's note about a person,
 * and a note that scrolls out of sight while it is being written is a note that gets abbreviated.
 */
function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'field-sizing-content min-h-20 w-full rounded-md border border-input bg-control px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
